export default {"src":"/_next/static/media/logo.b0a9a6d7.svg","height":43,"width":43,"blurWidth":0,"blurHeight":0};